import React from 'react';
import { Button, PageTitle } from '@cordata/buffet';
import { useHistory, useParams, Link } from 'react-router-dom';

import { Table } from '~/components/Allergy';

const AllergiesCollection = () => {
  const history = useHistory();
  const params = useParams();

  const onClick = item =>
    history.push(`/patients/${params.patient_id}/allergies/${item.id}`);

  return (
    <>
      <PageTitle
        action={
          <Button
            outline
            tag={Link}
            to={`/patients/${params.patient_id}/allergies/add`}
            icon="plus"
          >
            Add Allergy
          </Button>
        }
      >
        Allergies
      </PageTitle>

      <Table
        params={{
          patient_uid: params.patient_id,
        }}
        onClick={onClick}
      />
    </>
  );
};

export default AllergiesCollection;
